<template>
  <div id="about-index">
    <header-section :subnav_show="false" :change_color="true"></header-section>
    <!-- ======= Hero Section ======= -->
    <div id="hero-about" data-aos="zoom-out" data-aos-delay="100"></div>

    <div class="location" data-aos="fade-up" data-aos-delay="100">
      <div class="w1200 clearfix">
        <div class="left-nav">
          <a href="/about" class="active" title="企业简介">企业简介</a>
          <a href="/history" title="发展历程">发展历程</a>
          <a href="/honor" title="荣誉资质">荣誉资质</a>
        </div>
      </div>
    </div>

    <div class="section-company bg-lightWhite text-align-center">
      <div class="clearfix">
        <div class="section-title mt-5">
          <h2>企业简介</h2>
          <p>二十年励精图治,铸就行业先锋</p>
        </div>
        <div class="w1200 div-txt-center padding-tb-30">
          <img style="width: 700px; height: 331px" src="@/assets/guanyu.png" />
        </div>
        <div class="w1200 about-content padding-tb-30">
          <div class="div-txt-left">
            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              科瑞达仪器科始创于上世纪八十年代，2006成立股份有限公司,专注过程水质在线分析和环保分析仪器、传感器，全部自研拥有自主知识产权。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;数十载励精图治、厚积薄发、匠心独具，拥有电子、电化学、光学、光电子、物理、自动控制、物联网、传感器等多维度专业群，形成水质分析仪器、集成装备、科学仪器等百余种产品，服务于电力、石化、煤化、冶金、新能源、液冷、半导体等高端制造，以及市政水务、环境保护、水质净化、海水淡化、污水处理、科技农业等领域，提供水质过程分析仪器和集成装备，建成面积50亩（建筑面积3.3万平方米）的独立式产业园区，是迄今国内大型过程水质分析仪器制造基地。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              注册资本4620万元（实有资产数亿元），国家级高新技术开发区注册企业，被认定为优秀高新技术创新型企业、瞪羚企业、小巨人企业。旗下多家子公司从事一线运营。上市企业简称：科瑞达仪器，股票代码：832189。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              随着仪器发展的深化，为获得发展的可持续性先后与西安交大、燕山大学、河北工大、天津南开大学、航空航天大学、铁道大学、河北科技大学、河北师范大学等多所院校以及研究所建立了产、学、研相结合校企合作关系，使资源达到优化配置。科瑞达仪器也成为一线院校实习和人才培训基地。
            </p>

            <p>
              &nbsp;&nbsp;&nbsp;&nbsp;
              在传感器、仪器、自控集成等硬件制造方面运用现代先进制造手段拥有规模化的自动生产线，在质量品管方面规范执行ISO9001、ISO14001等体系认证，在行业中率先实现了对传感器、数字化感知发送器、现场处理模块、整机产品的智能化自动检测，成就产品制造的一致性、重复性、可靠性，以坚持不懈的追求领跑行业制造之先锋。公司自有知识产权70多项，其中发明专利8项，软著40项，已受理的发明技术5项目
            </p>
          </div>
        </div>
        <div class="w1200">
          <img
            src="@/static/img/about/company2.jpg"
            style="height: 210px; padding: 0 8px" />
          <img
            src="@/static/img/about/company3.jpg"
            style="height: 210px; padding: 0 8px" />
          <img
            src="@/static/img/about/company4.jpg"
            style="height: 210px; padding: 0 8px" />
        </div>
      </div>
    </div>

    <div
      class="section-company section-bg text-align-center"
      style="height: 650px">
      <div class="w1200 div-txt-center mt-5">
        <h1>愿景使命</h1>
      </div>
      <el-row class="mt-4">
        <el-col :span="12">
          <div class="div-right">
            <h2>愿 景 VISION</h2>
            <p>共建碧水青山,不忘初心,砥砺向前!</p>
            <h2 style="margin-top: 30px">使 命 MISSION</h2>
            <p>◆ 对社会：促进和谐 担当责任</p>
            <p>◆ 对行业：放心产品 贴心服务</p>
            <p>◆ 对员工：享受发展 后顾无忧</p>
            <p>◆ 对股东：放心投资 持续回报</p>
            <p>◆ 对伙伴：相互促进 发展共赢</p>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="div-left">
            <img
              src="@/static/img/about/company5.jpg"
              style="width: 610px; height: 440px" />
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="section-company text-align-center" style="height: 650px">
      <div class="w1200 div-txt-center mt-5">
        <h1>科瑞达精神</h1>
      </div>
      <div class="w1200-2 div-txt-center mt-4">
        <div class="row js-bg">
          <div class="col-lg-6 mt-4"></div>
          <div class="col-lg-6 mt-4">
            <div class="div-list">
              <p>
                ◆
                团结：团结对一个人来说是一种素质，对一个家庭来说是一种幸福，对一个团体来说是一种力量。团结是战胜一切困难的有力武器，是每一个员工应具有的优秀品质，是实现科瑞达宏伟目标的基本保证。
              </p>
              <p>
                ◆
                务实：坚持办实事、讲实话、求实效。实实在在做人，踏踏实实做事。不搞形式主义，坚持求真务实。
              </p>
              <p>
                ◆
                创新：认真打造和完善全员创新体系，积极有效采纳合理化建议。支持奖励技术革新，小改小革。不断创新生产工艺，优化技术指标，改善管理手段，提升管理效率，开拓品种与市场。
              </p>
              <p>
                ◆
                拼搏：三分天注定，七分靠打拼，爱拼才会赢。拼搏是对理想的追求，是为达到目标的一种执着。只有搏击风雨，大地才能春华秋实。只有勇往直前，才能所向披靡。拼搏是科瑞达人进取向上，努力奋斗的精神。
              </p>
              <p>
                ◆
                奉献：科瑞达是我家，建设靠大家。科瑞达与员工休戚相关，荣辱与共，需要共同无私奉献。奉献是人生真正的价值，奉献是科瑞达生存发展的保证。我们要用爱心和责任铸成一道清新飘逸的彩虹，用真情和奉献呵护我们科瑞达健康发展。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 公司资质模块：滚动逐个上浮动画 -->
    <div class="section-company manage-system-section text-align-center">
      <div class="w1200 div-txt-center mt-5" data-aos="fade-up">
        <h1>公司资质</h1>
      </div>
      <div class="w1200 manage-system-list">
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="0">
          <div class="manage-system-card-img">
            <img src="../assets/gaoxinqiye.png" alt="高新技术企业" />
          </div>
          <div class="manage-system-card-title">高新技术企业</div>
        </div>
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="100">
          <div class="manage-system-card-img">
            <img src="../assets/dengling.png" alt="瞪羚企业" />
          </div>
          <div class="manage-system-card-title">瞪羚企业</div>
        </div>
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="200">
          <div class="manage-system-card-img">
            <img src="../assets/zhengshu.png" alt="荣誉证书" />
          </div>
          <div class="manage-system-card-title">资质认证</div>
        </div>
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="300">
          <div class="manage-system-card-img">
            <img src="../assets/yiqi.png" alt="荣誉称号" />
          </div>
          <div class="manage-system-card-title">荣誉称号</div>
        </div>
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="100">
          <div class="manage-system-card-img">
            <img src="../assets/faming.png" alt="发明专利" />
          </div>
          <div class="manage-system-card-title">发明专利</div>
        </div>
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="200">
          <div class="manage-system-card-img">
            <img src="../assets/qianzi.png" alt="签约仪式" />
          </div>
          <div class="manage-system-card-title">签约仪式</div>
        </div>
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="300">
          <div class="manage-system-card-img">
            <img src="../assets/zhuanjingtexin.png" alt="国家级小巨人企业" />
          </div>
          <div class="manage-system-card-title">国家级小巨人企业</div>
        </div>
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="400">
          <div class="manage-system-card-img">
            <img src="../assets/shifanqiye.png" alt="专精特新企业" />
          </div>
          <div class="manage-system-card-title">专精特新企业</div>
        </div>
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="200">
          <div class="manage-system-card-img">
            <img src="../assets/lvyingjiang.jpg" alt="绿英奖" />
          </div>
            <div class="manage-system-card-title">绿英奖</div>
        </div>
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="300">
          <div class="manage-system-card-img">
            <img src="../assets/zhongxinyong.png" alt="重信用企业证书" />
          </div>
          <div class="manage-system-card-title">重信用企业证书</div>
        </div>
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="400">
          <div class="manage-system-card-img">
            <img src="../assets/xiaodengta.png" alt="小灯塔" />
          </div>
          <div class="manage-system-card-title">小灯塔</div>
        </div>
        <div class="manage-system-card" data-aos="fade-up" data-aos-delay="500">
          <div class="manage-system-card-img">
            <img src="../assets/lingjunqiye.jpg" alt="领军企业" />
          </div>
          <div class="manage-system-card-title">领军企业</div>
        </div>
      </div>
    </div>

    <!-- 服务保障模块：左右交替滑入动画 -->
    <div class="section-company service-guarantee-section text-align-center">
      <div class="w1200 div-txt-center mt-5" data-aos="fade-up">
        <h1>服务保障</h1>
        <p class="service-guarantee-desc">公司在全国范围内建立了完善的销售和售后服务保障体系，保障客户使用过程更安心。</p>
      </div>
      <div class="w1200 service-guarantee-list">
        <div class="service-guarantee-item" data-aos="fade-right" data-aos-delay="0">北京恒泰翔基科技有限公司</div>
        <div class="service-guarantee-item" data-aos="fade-left" data-aos-delay="100">山东科瑞达大环境科技有限公司</div>
        <div class="service-guarantee-item" data-aos="fade-right" data-aos-delay="100">广东科瑞达环境科技发展有限公司</div>
        <div class="service-guarantee-item" data-aos="fade-left" data-aos-delay="200">上海科瑞达仪器科技有限公司</div>
        <div class="service-guarantee-item" data-aos="fade-right" data-aos-delay="200">杭州科瑞达仪器科技股份有限公司</div>
        <div class="service-guarantee-item" data-aos="fade-left" data-aos-delay="300">海南科瑞达环境科技有限公司</div>
        <div class="service-guarantee-item" data-aos="fade-right" data-aos-delay="300">科瑞达(宜兴)科技有限公司</div>
        <div class="service-guarantee-item" data-aos="fade-left" data-aos-delay="400">河北科瑞达仪器科技股份有限公司-成都办事处</div>
        <div class="service-guarantee-item" data-aos="fade-right" data-aos-delay="400">河北科瑞达仪器科技股份有限公司-新疆办事处</div>
        <div class="service-guarantee-item" data-aos="fade-left" data-aos-delay="500">石家庄嘉耀测控技术有限公司</div>
      </div>
    </div>

    <div class="section-company corporate-vision-section text-align-center">
      <div class="vision-bg">
        <img class="vision-img" src="@/assets/yuanjing.png" alt="企业愿景" />
        <div class="vision-overlay">
          <div class="vision-content">
            <h1>企业愿景</h1>
            <p>
              秉持以水为圆心，深耕水质在线分析仪器，专注水质感知技术和分析仪器的研发，依托感知终端核心技术，深入应用场景的工艺研究，全域赋能水环境智能监测＆水质管控，助力经济的可持续发展与民生改善。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <footer-section></footer-section>
  </div>
</template>

<script>
import HeaderSection from "@/components/public/head.vue";
import FooterSection from "@/components/public/footer.vue";

export default {
  components: {
    HeaderSection,
    FooterSection,
  },
  props: {},
  data() {
    return {
      articleId: 0,
      articleDetail: {},
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {
    //添加标题和meta标签
    let arr = [
      "首页",
      "产品中心",
      "解决方案",
      "客户案例",
      "新闻动态",
      "人才招聘",
      "关于我们",
      "联系我们",
    ];
    document.title = "关于我们-河北科瑞达仪器科技股份有限公司";
    let m = document.querySelectorAll("meta");
    const meta = document.createElement("meta");
    meta.name = "keywords";
    for (let i = 0; i < m.length; i++) {
      arr.some((item) => {
        if (item == m[i].content) {
          m[i].remove();
        }
      });
      if (m[i].content == "公司简介") {
        m[i].remove();
      }
    }
    meta.content = "公司简介";
    m[0].after(meta);
    for (let i = 0; i < m.length; i++) {
      if (m[i].content == "河北科瑞达仪器科技股份有限公司") {
        m[i].remove();
      }
    }
  },
  mounted() {
    // 初始化AOS滚动动画配置
    if(window.AOS){
      AOS.init({
        duration: 800,
        offset: 120,
        once: true,
        easing: "ease-out-cubic"
      });
    }
  },
};
</script>

<style scoped>
#about-index {
  overflow-x: hidden;
}
/*--------------------------------------------------------------
# Hero Section
--------------------------------------------------------------*/
#hero-about {
  width: 100%;
  height: 45vh;
  background: url("~@/static/img/banner/about-banner.jpg");
  background-size: cover;
  position: relative;
}

.w1200 {
  width: 100%;
  max-width: 1200px;
  padding: 0 30px;
  margin: 0 auto;
}
.w1200-2 {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
.mt-5 {
  margin-top: 50px;
}
.mt-4 {
  margin-top: 50px;
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}
/* ========= */
/*  about-us */
/* ========= */
.location {
  width: 100%;
  box-shadow: -10px -22px 30px 8px rgba(0, 0, 0, 0.5);
}
.location .left-nav {
  float: left;
}
.location .left-nav a {
  display: inline-block;
  line-height: 50px;
  font-size: 16px;
  color: #666;
  text-align: center;
  padding: 0 20px;
}
.location .left-nav a.active {
  background: #276dc1;
  color: #fff;
}
.box-shadow {
  box-shadow: 0px 30px 25px 18px rgba(0, 0, 0, 0.5);
}
.bg-lightWhite {
  background: #fefefe;
}
.text-align-center {
  text-align: center;
}
.padding-tb-30 {
  padding: 30px 0;
}
.padding-lr-30 {
  padding: 30px 0;
}
.section-company {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 0px;
}
.section-company .div-img {
  margin: 30px 0;
  width: 100%;
  cursor: pointer;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
}
.about-content {
  width: 80%;
  text-align: center;
  line-height: 40px;
}
.section-bg {
  background-color: #f6f9fe;
}
.div-txt-center h1 {
  color: #000;
  font-size: 32px;
  font-weight: 800;
  line-height: 150%;
  text-align: center;
}
.div-txt-center h2 {
  color: #333;
  font-size: 18px;
  line-height: 150%;
}

/* ====================== 单行横向交替错落卡片核心样式 ====================== */
.manage-system-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px 22px;
  padding: 20px 0 60px;
}
.manage-system-card {
  width: calc(25% - 24px);
  min-width: 220px;
  max-width: 300px;
  background: #fff;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  transform: translateY(0);
}
/* 偶数卡片向下偏移，实现一高一低交替错落效果 */
.manage-system-list > .manage-system-card:nth-child(even) {
  transform: translateY(32px);
}
/* hover动效优化 */
.manage-system-card:hover {
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.14);
}
.manage-system-list > .manage-system-card:nth-child(odd):hover {
  transform: translateY(-10px);
}
.manage-system-list > .manage-system-card:nth-child(even):hover {
  transform: translateY(22px);
}
.manage-system-card-img {
  background: #f7f9ff;
  padding: 20px;
}
.manage-system-card-img img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 12px;
}
.manage-system-card-title {
  padding: 18px 20px;
  font-size: 16px;
  font-weight: 700;
  color: #0f56ff;
  line-height: 1.5;
  text-align: center;
}
/* 废弃旧偏移类 */
.manage-system-card-offset {
  display: none;
}
/* ================================================================= */

.service-guarantee-section {
  background: #f8fbff;
  padding-bottom: 50px;
}
.service-guarantee-desc {
  color: #5f6f88;
  font-size: 16px;
  margin-top: 12px;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
}
.service-guarantee-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(260px, 1fr));
  gap: 16px;
  margin-top: 32px;
  justify-items: stretch;
}
.service-guarantee-item {
  background: #fff;
  border: 1px solid rgba(15, 86, 255, 0.12);
  border-radius: 14px;
  padding: 20px 24px;
  color: #27314d;
  font-size: 16px;
  line-height: 1.75;
  box-shadow: 0 12px 30px rgba(15, 86, 255, 0.08);
}
.service-guarantee-item:nth-child(odd) {
  transform: translateY(0);
}

/* 平板适配 3列 */
@media (max-width: 1100px) {
  .manage-system-card {
    width: calc(33.33% - 20px);
  }
}
/* 平板适配 2列 */
@media (max-width: 820px) {
  .manage-system-card {
    width: calc(50% - 16px);
  }
  .manage-system-list > .manage-system-card:nth-child(even) {
    transform: translateY(20px);
  }
  .service-guarantee-list {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
  }
}
/* 手机端单列，取消错位 */
@media (max-width: 600px) {
  .manage-system-card {
    width: 100%;
    max-width: 340px;
  }
  .manage-system-list > .manage-system-card:nth-child(even) {
    transform: translateY(0);
  }
  .manage-system-list > .manage-system-card:nth-child(odd):hover,
  .manage-system-list > .manage-system-card:nth-child(even):hover {
    transform: translateY(-8px);
  }
  .service-guarantee-list {
    grid-template-columns: 1fr;
  }
  .service-guarantee-item:nth-child(even) {
    transform: translateY(0);
  }
}

.corporate-vision-section {
  margin-top: 40px;
}

.vision-bg {
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

.vision-img {
  display: block;
  width: 100%;
  height: auto;
}

.vision-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  width: 55%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 40px;
}

.vision-content {
  width: 100%;
}

.vision-overlay h1 {
  color: #fff;
  font-size: 32px;
  font-weight: 800;
  margin-bottom: 20px;
  text-align: center;
}

.vision-overlay p {
  color: #fff8c6;
  font-size: 18px;
  line-height: 2;
  margin: 0 auto;
  text-align: center;
  letter-spacing: 2px;
  font-weight: 600;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.45);
}

.div-txt-left p {
  text-align: left;
  letter-spacing: 4px;
  font-size: 16px;
  line-height: 40px;
}
.div-left {
  float: left;
  width: 610px;
  height: 380px;
  text-align: center;
}
.div-right {
  float: right;
  width: 530px;
  height: 380px;
  text-align: center;
  padding: 30px;
  background: rgba(203, 230, 249, 1);
  line-height: 40px;
}
.center {
  width: 1200px;
  margin: 0 auto;
}
.div-list {
  float: left;
  width: 100%;
  text-align: left;
  line-height: 40px;
}
.js-bg {
  height: 500px;
  margin: 0 0 0 0;
  background-position: bottom;
  background-image: url("~@/static/img/about/company_content_bg.jpg") !important;
  background-repeat: repeat-x;
}

/* ========= AOS动画增强自定义样式 ========= */
/* 资质卡片上浮初始状态 */
.manage-system-card[data-aos="fade-up"] {
  opacity: 0;
  transform: translateY(40px);
  transition-property: transform, opacity, box-shadow;
}
.manage-system-card[data-aos="fade-up"].aos-animate {
  opacity: 1;
  transform: translateY(0);
}
/* 偶数卡片入场后保留原有向下偏移 */
.manage-system-list > .manage-system-card:nth-child(even).aos-animate {
  transform: translateY(32px);
}

/* 服务保障 从左侧滑入 */
.service-guarantee-item[data-aos="fade-right"] {
  opacity: 0;
  transform: translateX(-60px);
  transition-property: transform, opacity;
}
.service-guarantee-item[data-aos="fade-right"].aos-animate {
  opacity: 1;
  transform: translateX(0);
}

/* 服务保障 从右侧滑入 */
.service-guarantee-item[data-aos="fade-left"] {
  opacity: 0;
  transform: translateX(60px);
  transition-property: transform, opacity;
}
.service-guarantee-item[data-aos="fade-left"].aos-animate {
  opacity: 1;
  transform: translateX(0);
}
</style>